
const _font = {
  fontFamilyDefault: {
    fontFamily: 'HP Simplified',
    fontWeight: 400,
    lineHeight: '1em',
    fontStyle: 'normal',
  },
  h1: {
    fontWeight: '700',
    fontSize: '32px',
    lineHeight: '150%',
  },
  h2: {
    fontStyle: 'normal',
    fontWeight: '700',
    fontSize: '18px',
    lineHeight: '21px',
  },
  h3: {
    fontWeight: '700',
    fontSize: '16px',
    lineHeight: '25px',
    letterSpacing: '0.1px',
  },
  h4: {
    fontWeight: '700',
    fontSize: '32px',
    lineHeight: '150%',
    marginBlockStart: '1em',
    marginBlockEnd: '1em',
  },
}

export default _font
